import { render, staticRenderFns } from "./TourInfoProperties.vue?vue&type=template&id=3e982fb2&scoped=true&"
import script from "./TourInfoProperties.vue?vue&type=script&lang=js&"
export * from "./TourInfoProperties.vue?vue&type=script&lang=js&"
import style0 from "./TourInfoProperties.vue?vue&type=style&index=0&id=3e982fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e982fb2",
  null
  
)

export default component.exports